import { render, staticRenderFns } from "./review-section.vue?vue&type=template&id=734bd6df&"
import script from "./review-section.vue?vue&type=script&lang=js&"
export * from "./review-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports